<template>
  <div class="links-download-apps">
    <p class="text-center" v-if="showIcon">
      <a href="/" target="_blank">
        <img v-if="isPlantsEnv"
          class="logo-img"
          src="../../assets/logo-120x120.png"
          height="auto"
          alt="Logo"
        />
        <img v-else
          class="logo-img"
          src="../../assets/logo-cvc-120x120.png"
          height="auto"
          alt="Logo"
        />
      </a>
    </p>
    <slot v-if="isPlantsEnv && donwloadVisibility">
      <p class="text-center">Descargar</p>
    </slot>
    <div class="text-center p-3" v-if="showArrow && isPlantsEnv && donwloadVisibility">
      <Arrow />
    </div>
    <div
       v-if="isPlantsEnv && donwloadVisibility"
      class="row"
      v-bind:class="{ 'row-cols-1': isVertical, 'row-cols-2': !isVertical }"
    >
      <div class="col my-1">
        <a
          v-bind:href="playstoreUrl"
          target="_blank"
          class="mb-2"
          style="margin-left: 1px"
        >
          <img
            width="100%"
            src="../../assets/playstore.png"
            alt="playstore icon"
          />
        </a>
      </div>
      <div class="col my-1">
        <a
          v-bind:href="appstoreUrl"
          target="_blank"
          class="mb-2"
          style="margin-right: 1px"
        >
          <img
            width="100%"
            src="../../assets/appstore.png"
            alt="appstore icon"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import APP_IDS from '../../constants';
import Arrow from './Arrow.vue';

export default {
  name: 'LinksDownloadApps',
  components: {
    Arrow,
  },
  props: {
    orientation: {
      type: String,
      default: 'horizontal',
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    showArrow: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isVertical() {
      return this.orientation === 'vertical';
    },
  },
  data() {
    const currentEnv = process.env.VUE_APP_APP_ID ?? APP_IDS.Plants;
    return {
      appstoreUrl: process.env.VUE_APP_APPSTORE_URL,
      playstoreUrl: process.env.VUE_APP_PLAYSTORE_URL,
      isPlantsEnv: currentEnv === APP_IDS.Plants,
      donwloadVisibility: false,
    }; // isPlantsEnv: ,
  },
};
</script>

<style lang="scss" scoped>
  a {
    max-width: 100%;
  }
  .logo-img {
    max-width: 100%;
    height: auto;
  }
</style>
